export function activateDocument (state, { competitionId, documentId }) {
	const competitionIndex = state.competitions.findIndex(competition => competition.id === competitionId);

	if (competitionIndex >= 0) {
		const document = state.competitions[competitionIndex].documents.find(document => document.id === documentId);

		if (document) document.isActive = !document.isActive;
	}
}
